import Tone from 'tone';

export default superclass => class extends superclass  {
    scaleByKey(time, transpose,  voiceNumber) {
        if (!this.track.parametersToScale) {
            let parameters = this.track ? this.track.getAllParameters() : this.getParameters();
            this.track.parametersToScale = parameters.filter(
                x => x.keyScaling);
        }

        let minTranspose = -32;
        let maxTranspose = 60;
        let transposeRatio = (transpose - minTranspose) / (maxTranspose - minTranspose);

        let {isOffline} = Tone.Master.context;

        for (let parameter of this.track.parametersToScale) {
            let {keyScaling} = parameter;
            if (!keyScaling) {
                continue;
            }
            let scaledValue = parameter.get(true) + keyScaling.min + (keyScaling.max - keyScaling.min) * transposeRatio;

            // now check for audio param vs audio params
            if (parameter._audioParams) {
                let len = parameter._audioParams.length;
                if (isOffline) {
                    parameter._audioParams[voiceNumber % len].value = scaledValue;
                } else {
                    parameter._audioParams[voiceNumber % len].linearRampToValueAtTime(
                        scaledValue, time + 0.01);
                }
            } else if (parameter.audioParam && parameter.audioParam.linearRampToValueAtTime) {
                if (isOffline) {
                    parameter.audioParam.value = scaledValue;
                } else {
                    parameter.audioParam.linearRampToValueAtTime(
                        scaledValue, time + 0.01);
                }
            } else if (parameter.audioParams && parameter.audioParams[voiceNumber]) {
                if (isOffline) {
                    parameter.audioParams[voiceNumber].value = scaledValue;
                } else {
                    parameter.audioParams[voiceNumber].linearRampToValueAtTime(
                        scaledValue, time + 0.01);
                }
            } else {
                parameter.setter(parameter.object, scaledValue);
            }
        }
    }
}
